import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEYS = {
  client: "kn_client_token",
  vendor: "kn_vendor_token",
  admin: "kn_admin_token",
};

export const getToken = (role) => localStorage.getItem(TOKEN_KEYS[role]);
export const setToken = (role, t) => {
  if (t) localStorage.setItem(TOKEN_KEYS[role], t);
  else localStorage.removeItem(TOKEN_KEYS[role]);
};

export const api = axios.create({ baseURL: API });

// Global auth guard: if a deleted/suspended account (or invalid session) makes any
// request, kick it out immediately so there are no "ghost" sessions after deletion.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const isAuthKill =
      status === 401 ||
      (status === 403 && typeof detail === "string" && detail.startsWith("Account"));
    if (isAuthKill) {
      const authHeader = error?.config?.headers?.Authorization || "";
      const usedToken = authHeader.replace(/^Bearer\s+/, "");
      if (usedToken) {
        ["client", "vendor", "admin"].forEach((role) => {
          if (getToken(role) && getToken(role) === usedToken) {
            setToken(role, null);
            window.dispatchEvent(
              new CustomEvent("kn-auth-expired", {
                detail: { role, message: typeof detail === "string" ? detail : "" },
              })
            );
          }
        });
      }
    }
    return Promise.reject(error);
  }
);

export const authHeaders = (role) => {
  const t = getToken(role);
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Extract a readable Italian error message from an axios error.
export function errMessage(err, fallback = "Si è verificato un errore. Riprova.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(", ") || fallback;
  if (d && typeof d === "object") return d.msg || fallback;
  return err?.message || fallback;
}
